module.exports = __webpack_public_path__ + "static/media/optimma-logo.8c3930ae.svg";